export default "__VITE_ASSET__CNVprT9U__"